import { configureStore } from '@reduxjs/toolkit'
import isLoggedInReducer from './isLoggedIn' // isLoggedInReducer is an alias. It can be anything apparently. How the F does this work
import firstAppLoad from './firstAppLoad'
import rallyTracker from './rallyTracker'


const store = configureStore({
  reducer: {
    isLoggedIn: isLoggedInReducer,
    firstAppLoad:firstAppLoad,
    rallyTracker:rallyTracker
  },
})
export default store;




